import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AssessmentMockService } from '../services/assessment-mock.service';

@Component({
  selector: 'app-assessment-thanks',
  templateUrl: './assessment-thanks.component.html',
  styleUrls: ['./assessment-thanks.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AssessmentThanksComponent implements OnInit {
  token!: string;
  presenterName = '';
  presenterEmail = '';
  // newsletter (mocked)
  nlEmail = ''; nlConsent = false; nlDone = false;

  constructor(private route: ActivatedRoute, private svc: AssessmentMockService) {}

  ngOnInit(): void {
    this.token = this.route.snapshot.paramMap.get('token')!;
    const inv = this.svc.invitationFor(this.token);
    // The participant's contact is the presenter (results are held by them for the session);
    // fall back to the owner/first organizer when no presenter role is assigned.
    const contact = inv?.organizers.find(o => o.role === 'presenter') ?? inv?.organizers[0];
    this.presenterName = contact?.name ?? 'your presenter';
    this.presenterEmail = contact?.email ?? '';
  }

  nlSubmit(): void {
    if (!this.nlEmail || !this.nlConsent) { return; }
    this.nlDone = true; // mocked — no backend
  }
}
